'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var defaultHistoryObject = {
  pathname: ''
};

var previousLocationSelectorFactory = exports.previousLocationSelectorFactory = function previousLocationSelectorFactory(reducerName) {
  return function (state) {
    return state[reducerName].previousLocation || defaultHistoryObject;
  };
};

var activeLocationSelectorFactory = exports.activeLocationSelectorFactory = function activeLocationSelectorFactory(reducerName) {
  return function (state) {
    return state[reducerName].activeLocation || defaultHistoryObject;
  };
};